import React from "react";
import { Radio } from 'antd';

import PropTypes from 'prop-types';
function URRadio(props: any) {
  let {name, onChange, checked,disabled, value, ...restProps } = props;
  return (
    <>
      <Radio value={value} checked={checked} disabled={disabled} name={name} onChange={props.onChange} {...restProps}/>
    </>

  );
}

export {
  URRadio
};

URRadio.propTypes = {
  onChange: PropTypes.any,
  name: PropTypes.any,
  checked: PropTypes.any,
  value: PropTypes.any
};